import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
// import firebase from 'firebase/app';
import { initializeApp } from '@firebase/app';
import { getAuth } from '@firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { getStorage } from '@firebase/storage';
import { createRouter, createWebHistory } from 'vue-router';

//supabase auth
import { createClient } from '@supabase/supabase-js';
import { useAuthStore } from './stores/auth.js';

// app router
import Login from './views/app/pages/Login.vue';
import Signup from './views/app/pages/Signup.vue';
import Workboards from './views/app/pages/Workboards.vue';
import BoardList from './views/app/pages/BoardList.vue';
import NewBoard from './views/app/pages/NewBoard.vue';
import Temp from './views/app/pages/Temp.vue';
import Connections from './views/app/pages/Connections.vue';
import DemoBoard from './views/app/pages/DemoBoard.vue';
import ExtAuth from './views/app/pages/ExtAuth.vue';

// labs router
import Labs from './views/labs/Labs.vue';

// documentation router
import Documentation from './views/docs/Documentation.vue';
import DocAuth from './views/docs/DocAuth.vue';

// auth router
import Google from './views/auth/Google.vue';

// Import Vue Flow styles
import '@vue-flow/core/dist/style.css';
import '@vue-flow/core/dist/theme-default.css';

var firebaseConfig = {
    apiKey: "AIzaSyDcP0Y8XwUTyMZA7YFOhPfmS7FyO8Phmys",
    authDomain: "moonarch-portal.firebaseapp.com",
    projectId: "moonarch-portal",
    storageBucket: "moonarch-portal.appspot.com",
    messagingSenderId: "810813954667",
    appId: "1:810813954667:web:b10cf75110e1f0a4d2ef2e",
    measurementId: "G-L90H3Q1ZBC"
};

// const searchParams = new URLSearchParams(window.location.search);

const appRoutes = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: { 
        requiresAuth: false,
        },
      component: Login,
    },
    {
      path: '/signup',
      name: 'Signup',
      meta: { 
        requiresAuth: false,
        },
      component: Signup,
    },
    {
      path: '/workboards', //:subdomain/portal
      name: 'Workboards',
      meta: { requiresAuth: true },
      component: Workboards,
    },
    {
      path: '/boardlist',
      name: 'BoardList',
      meta: { requiresAuth: true },
      component: BoardList,
    },
    {
      path: '/newboard',
      name: 'NewBoard',
      meta: { requiresAuth: true },
      component: NewBoard,
    },
    {
      path: '/connections',
      name: 'Connections',
      meta: { requiresAuth: true },
      component: Connections,
    },
    {
      path: '/temp',
      name: 'Temp',
      meta: { requiresAuth: true },
      component: Temp,
    },
    {
      path: '/demoboard',
      name: 'DemoBoard',
      meta: { requiresAuth: false },
      component: DemoBoard,
    },
    {
      path: '/google',
      name: 'ExtAuth',
      meta: { requiresAuth: true },
      component: ExtAuth,
    },
    
  ],
});

const labsRoutes = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Labs',
      meta: { requiresAuth: false },
      component: Labs,
    },
  ],
});

const docsRoutes = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:doctype/:doc',
      name: 'Documentation',
      meta: { requiresAuth: true },
      component: Documentation,
    },
    {
      path: '/',
      name: 'DocAuth',
      meta: { requiresAuth: false },
      component: DocAuth,
    },
  ],
});

const authRoutes = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/google',
      name: 'Google',
      meta: { requiresAuth: false },
      component: Google,
    },
  ],
});

// Detect subdomain
const subdomain = window.location.hostname.split('.')[0];

// Choose routes based on subdomain
let routes = [];
if (subdomain === 'app') {
  routes = appRoutes;
} else if (subdomain === 'docs') {
  routes = docsRoutes;
} else if (subdomain === 'labs') {
  routes = labsRoutes;
} else if (subdomain === 'auth') {
  routes = authRoutes;
}
routes.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Always fetch latest user info from Supabase
  await authStore.fetchUser(); 
  const currentUser = authStore.user;

  console.log("Supabase user:", currentUser);

  const subdomain = window.location.hostname.split('.')[0];
  // const searchParams = new URLSearchParams(window.location.search);

  if (to.meta.requiresAuth && subdomain !== "docs") {
    console.log(to.fullPath);
    if (currentUser) {
      next();
    } else {
      next({ 
        name: 'Login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else if (to.meta.requiresAuth && subdomain === "docs") {
    if (!currentUser) {
      next({ name: 'DocAuth' });
    } else {
      const cleanPath = to.path.replace(/^\/|\/$/g, '');
      if (to.path === "/") {
        next({ name: 'Documentation', params: { doctype: 'documentation', doc: 'overview' } });
      } else if (["documentation", "endpoints"].includes(cleanPath)) {
        next({ name: 'Documentation', params: { doctype: cleanPath, doc: 'overview' } });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

const defaultTitle = 'Moonarch';
routes.afterEach((to) => {
  document.title = 'Moonarch | ' + to.name || defaultTitle;
});

// Initialize Firebase
const firebase_app = initializeApp(firebaseConfig);
const db = getFirestore(firebase_app);
const auth = getAuth(firebase_app);
const storage = getStorage(firebase_app);

const app = createApp(App);
const pinia = createPinia();
app.use(routes);
app.use(pinia);
app.mount('#app');

const supabaseUrl="https://yubjhozwvjkpaoyzmnaq.supabase.co"
const supabaseKey="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl1Ympob3p3dmprcGFveXptbmFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTE0MDE1NjIsImV4cCI6MjAyNjk3NzU2Mn0.MYvcw7CIAiXU3Y77a5zr8a4bcqJU851iFsxY6QypB54"

const supabase = createClient(supabaseUrl, supabaseKey);

export {db, auth, storage, supabase };